<section class="order-general-information">
  <!-- Order Information -->
  <p-panel header="Order Information" aria-label="Order Information" styleClass="mb-3 panel-with-heading border">
    <section class="p-3">
      <!-- contact info section -->
      <section class="border-bottom-dotted">
        <div class="row mb-0 mb-lg-3">
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
            <label class="medium-text d-block">Ordered Date</label>
            <label>{{ orderDetails?.orderedDate }}</label>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
            <label class="medium-text d-block">Order Owner</label>
            <label>{{ orderDetails?.orderOwner }}</label>
          </div>
          @if(!isUserLinkedToAccount){
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Created By</label>
              <label>{{ orderDetails?.createdBy }}</label>
            </div>
          }
        </div>
          <h2 class="semi-bold-text mb-2 font-15 color-black">Contact Information</h2>
        @if(orderDetails?.contacts?.length){
          @for(contact of orderDetails?.contacts; let indx = $index; track contact){
          <div class="mb-3">
            <h3 class="semi-bold-text heading-color mb-2 font-15"> Contact {{ indx < 9 ? "0" + (indx + 1) : indx + 1 }}
            </h3>
              <div class="row mb-0 mb-lg-3">
                <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
                  <label class="medium-text d-block">Contact Name</label>
                  <label>{{ contact.displayName }}</label>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
                  <label class="medium-text d-block">Phone</label>
                  <label>{{ contact.phone || '--' }}</label>
                  <label *ngIf="contact.extension && contact.extension !== '--'">&nbsp; extn.&nbsp;{{contact.extension}}</label>
                </div>
                <!-- <div class="col mb-3 mb-sm-0" *ngIf="contact.extension && contact.extension !== '--'">
                  <label class="medium-text d-block">Extn</label>
                  <label>{{ contact.extension }}</label>
                </div> -->
                <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
                  <label class="medium-text d-block">Email</label>
                  <label>{{ contact.email || '--' }}</label>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
                  <label class="medium-text d-block">Title</label>
                  <label>{{ contact.title }}</label>
                </div>
              </div>
              @if(contact.barNumber){
              <div class="row mb-0 mb-lg-3">
                <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
                  <label class="medium-text d-block">Bar Number</label>
                  <label>{{ contact.barNumber || '-- '}}</label>
                </div>
              </div>
              }
        </div>
        }
      }
      </section>

      <!-- billing info section -->
      <section class="border-bottom-dotted mt-3">
        <h2 class="semi-bold-text mb-2 font-15 color-black">Billing Information</h2>
        <div class="row mb-0 mb-lg-3">
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
            <label class="medium-text d-block">Bill To</label>
            <label>{{ orderDetails?.billingInfo?.billTo || '--' }}</label>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
            <label class="medium-text d-block">Billing Email Address</label>
            <label>{{ orderDetails?.billingInfo?.email || '--' }}</label>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
            <label class="medium-text d-block">Adjuster Name</label>
            <label>{{ orderDetails?.adjusterInfo?.adjusterName }}</label>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
            <label class="medium-text d-block">Adjuster Email Address</label>
            <label>{{ orderDetails?.adjusterInfo?.email || '--' }}</label>
          </div>
        </div>
        <!-- New row for case matter -->
        <div class="row mb-0 mb-lg-3">
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0" *ngIf="orderDetails?.caseMatter">
            <label class="medium-text d-block">Case Matter</label>
            <label>{{ orderDetails?.caseMatter || '--' }}</label>
            </div>
        </div>
      </section>

      <!-- delivery info section -->
      <section class="border-bottom-dotted mt-3">
        <h2 class="semi-bold-text mb-2 font-15 color-black">Delivery Information</h2>
        <div class="row mb-0 mb-lg-3">
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
            <label class="medium-text d-block">Attention To</label>
            <label>{{ orderDetails?.deliveryInfo?.attentionTo || '--' }}</label>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
            <label class="medium-text d-block">Firm Name</label>
            <label>{{ orderDetails?.deliveryInfo?.firmTo || '--'  }}</label>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
            <label class="medium-text d-block">Phone</label>
            <label>{{ orderDetails?.deliveryInfo?.phone || '--'}}</label>
            <label *ngIf="orderDetails?.deliveryInfo?.extension && orderDetails?.deliveryInfo?.extension !== '--'">&nbsp;extn.&nbsp;{{orderDetails?.deliveryInfo?.extension || '--'}}</label>
          </div>
          <!-- <div class="col mb-3 mb-sm-0" *ngIf="orderDetails?.deliveryInfo?.extension">
            <label class="medium-text d-block">Extn</label>
            <label>{{ orderDetails?.deliveryInfo?.extension}}</label>
          </div> -->
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
            <label class="medium-text d-block">Address</label>
            <div class="d-flex flex-column">
              <label class="text-break" data-openreplay-obscured>{{ orderDetails?.deliveryInfo?.address || '--'  }}</label> <!-- address line one -->
              <!--<label>{{ orderDetails?.deliveryInfo?.address }}</label>--> <!-- address line two -->
            </div>
          </div>
        </div>
      </section>

      <!-- attachments section -->
      <section class="mt-3">
        <h2 class="semi-bold-text mb-2 font-15 color-black">Attachments</h2>
        <div class="row mb-0 mb-lg-3">
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0 labelContainer">
            <label class="medium-text d-block mb-1">Label</label>
            <div class="d-grid gap-0 row-gap-2">
              <div *ngFor="let attachment of orderDetails?.attachmentInfo">
              <label>{{ getDocTitleDescription(attachment.tagName, vocabDocumentTagsData) }}</label>
              </div>
              <div *ngIf="!orderDetails?.attachmentInfo?.length">
              <label>--</label>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
            <label class="medium-text d-block mb-1">Uploaded Files</label>
            <div class="d-grid gap-0 row-gap-2">
              <div *ngFor="let attachment of orderDetails?.attachmentInfo">
              <p-button aria-label="Downloadable File" styleClass="p-0" label="{{ attachment.fileName }}" (onClick)="downloadFile(attachment)" [link]="true" />
              </div>
              <!-- <a href="#" *ngFor="let attachment of orderDetails?.attachmentInfo" (onclick)="downloadFile(attachment)">{{ attachment.fileName }}</a> -->
              <div *ngIf="!orderDetails?.attachmentInfo?.length">
              <label>--</label>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Special Instructions -->
      @if(orderDetails?.specialInstructions){
      <section class="border-top-dotted pt-3">
        <h2 class="medium-text mb-2 font-15 color-black">Special Instructions</h2>
        <p class="m-0">
          {{ orderDetails?.specialInstructions }}
        </p>
      </section>
      }
    </section>
  </p-panel>

  <!-- Record Subjects -->
  <p-panel header="Record Subjects" aria-label="Record Subjects" styleClass="mb-3 panel-with-heading border">
    <!-- <div > -->
    <section class="p-3">
      @for(subject of orderDetails?.subjects; let indx = $index; let isLast = $last; track subject){
      <!-- <div> -->
      <h2 class="semi-bold-text heading-color mb-2 font-15">Subject {{ indx < 9 ? "0" + (indx + 1) : indx + 1 }}</h2>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Record Subject Name</label>
              <label data-openreplay-obscured>{{ subject.name }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Alias</label>
              <label>{{ subject.alias || "--" }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Date of Birth</label>
              <label>{{ subject.dateOfBirth | date: 'MM/dd/yyyy'  }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Last 4 digits of SSN</label>
              <label data-openreplay-obscured>{{ subject.lastDigitOfSSN || "--"}}</label>
            </div>
          </div>
          @if(subject.dateOfDeath){
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-12 mb-3 mb-sm-0">
              <label class="medium-text d-block">Date of Death (If Applicable)</label>
              <label>{{ subject.dateOfDeath | date: 'MM/dd/yyyy' }}</label>
            </div>
          </div>
          }
          <!-- </div> -->

          @if (!isLast) {
           <hr>
          }
        }
    </section>
    <!-- </div> -->
  </p-panel>

  <!-- add this code in new component -->

  <ng-template #panelTemplate let-counsels>
    <section>
      <h2 class="bold-text mb-3 font-20">Plaintiff Details</h2>
      @for(counsel of counsels; let indx = $index; let isLast = $last; track counsel) {
      <!-- <div> -->
      <h2 class="semi-bold-text mb-2 heading-color font-15"> Plaintiff Counsel {{ indx < 9 ? "0" + (indx + 1) : indx +
          1 }} </h2>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Plaintiff Counsel Full Name</label>
              <label>{{ counsel.plantiffCounselAttorneyName || "--"  }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Bar Number</label>
              <label>{{ counsel.plantiffCounselBarNumer || "--"  }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Law Firm</label>
              <label>{{ counsel.plantiffCounselFirmName || "--"  }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Representing - Plaintiff</label>
              <label>{{ getPlaintiffNames(counsel) }}</label>
            </div>
          </div>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Street Address</label>
              <div class="d-flex flex-column">
                <label class="text-break" data-openreplay-obscured>{{ counsel.streetAddress || "--" }}</label>
               </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Phone</label>
              <label>{{ counsel.phone || "--" }}</label>
              <label *ngIf="counsel.extension && counsel.extension !== '--'">&nbsp; extn.&nbsp;{{counsel.extension}}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Fax</label>
              <label>{{ counsel.fax || "--" }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Email</label>
              <label>{{ counsel.email || "--" }}</label>
            </div>
          </div>
          <!-- </div> -->

          }
    </section>
  </ng-template>

  <!-- Authorization to be Obtained by EXL Panel -->
  @if(orderDetails?.counselInfo?.length){
  <p-panel header="Authorization to be Obtained by EXL" aria-label="Authorization to be Obtained by EXL" styleClass="mb-3 panel-with-heading border"
    *ngIf="orderDetails?.typeOfOrder === 'Authorization not provided - EXL to obtain'">
    <div class="p-3">
      <div class="col-sm-12 col-md-6 col-lg mb-3 mb-lg-0">
        <label class="medium-text d-block">Case Number</label>
        <label>{{ orderDetails?.caseNumber || "--"}}</label>
      </div>
      <hr>
      <ng-container *ngTemplateOutlet="
          panelTemplate;
          context: { $implicit: orderDetails?.counselInfo }
        "></ng-container>
    </div>
  </p-panel>
  }

  <!-- Subpoena to be Prepared by EXL panel -->
  <p-panel header="Subpoena to be Prepared by EXL" aria-label="Subpoena to be Prepared by EXL" styleClass="mb-3 panel-with-heading border"
    *ngIf="orderDetails?.typeOfOrder === 'Subpoena to be prepared by EXL'">
    <!-- <div class="p-3"> -->
    <!-- counsel content -->
    <section class="p-3">
      <h2 class="bold-text mb-3 font-20">Case Information</h2>
      <!-- Court Details subsection  -->
           <div class="row mb-0 mb-lg-3">
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Case Number</label>
              <label>{{ orderDetails?.subpoena?.caseNumber || "--"}}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-9 mb-3 mb-lg-0">
              <label class="medium-text d-block">Case Name</label>
              <label>{{ orderDetails?.subpoena?.caseName || "--"  }}</label>
            </div>
          </div>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Judge</label>
              <label>{{ orderDetails?.subpoena?.judge || "--"}}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Court</label>
              <label>{{ orderDetails?.subpoena?.court || "--"  }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Court Address</label>
              <div class="d-flex flex-column">
                <label data-openreplay-obscured>{{ orderDetails?.subpoena?.courtAddress || "--"}}</label> <!-- address line one -->
                <!--<label>{{ orderDetails?.subpoena?.courtAddress || "--"}}</label>--> <!-- address line two -->
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Jurisdiction County</label>
              <label>{{ orderDetails?.subpoena?.jurisdictionCounty || "--"  }}</label>
            </div>
          </div>
      <hr>
      <ng-container *ngTemplateOutlet="
          panelTemplate;
          context: { $implicit: orderDetails?.subpoena?.counselInfo }
        "></ng-container>
      <!-- defendant content -->
      <hr>
      <h2 class="bold-text mb-3 font-20">Defendant Details</h2>
      @for(defendant of orderDetails?.subpoena?.defendant; let indx = $index; track defendant){
      <!-- <div> -->
      <h2 class="semi-bold-text mb-2 heading-color font-15">
        Defendant {{ indx < 9 ? "0" + (indx + 1) : indx + 1 }} </h2>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0" *ngIf="defendant.defendantCounselAttorneyName">
              <label class="medium-text d-block">Defendant Counsel Full Name</label>
              <label>{{ defendant.defendantCounselAttorneyName || "--"  }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0" *ngIf="defendant.defendantCounselAttorneyName">
              <label class="medium-text d-block">Bar Number</label>
              <label>{{ defendant.defendantCounselBarNumer || "--"  }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Law Firm</label>
              <label>{{ defendant.defendantCounselFirmName || this.orderDetails?.accountName  }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Representing - Defendant</label>
              <div class="d-flex flex-column">
                <label>{{ getDefendantNames(defendant)  }}</label>
              </div>
            </div>
          </div>
          <div class="row mb-0 mb-lg-3"  *ngIf="defendant.defendantCounselAttorneyName">
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Street Address</label>
              <div class="d-flex flex-column">
                <label class="text-break" data-openreplay-obscured>{{ defendant.streetAddress || "--" }}</label>
               </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Phone</label>
              <label>{{ defendant.phone || "--" }}</label>
              <label *ngIf="defendant.extn && defendant.extn !== '--'">&nbsp; extn.&nbsp;{{defendant.extn}}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Fax</label>
              <label>{{ defendant.fax || "--" }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Email</label>
              <label>{{ defendant.email || "--" }}</label>
            </div>
          </div>
          }
        <!-- <br> -->
          <!-- <div class="row mb-0 mb-lg-3">
            <div class="col-sm-12 col-md-6 col-lg mb-3 mb-lg-0">
              <label class="medium-text d-block">State</label>
              <label>{{ orderDetails?.subpoena?.state || "--" }}</label>
            </div>
          </div> -->
          <!-- </div> -->
    </section>
    <!-- </div>   -->
  </p-panel>

  <!-- Records section -->

  <p-panel header="Records" aria-label="Records" styleClass="mb-3 panel-with-heading border">
    <!-- <div class="p-3"> -->
    <section class="p-3">
      <ng-container *ngFor="let item of orderDetails?.providers | keyvalue: keepOriginalSorting; let indx = index; let isLast = last; trackBy: trackByKey">
        <ng-container *ngIf="item.value as provider">
      <!-- @for(item of orderDetails?.providers | keyvalue; let indx = $index; track item.key) {
        @let provider = item.value;  -->
      <!-- <div> -->
      <h2 class="semi-bold-text mb-2 font-15 heading-color">
        Provider {{ indx < 9 ? "0" + (indx + 1) : indx + 1 }} </h2>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Provider (Institution)</label>
              <label>{{ provider.provider }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Doctor</label>
              <label>{{ provider.doctor || "--" }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Address</label>
              <div class="d-flex flex-column">
                <label data-openreplay-obscured>{{ provider.address || "--"  }}</label> <!-- address line one -->
                <!--<label>{{ provider.address }}</label>--> <!-- address line two -->
              </div>
            </div>
            <!-- <div class="col-sm-12 col-md-6 col-lg mb-3 mb-lg-0">
              <label class="medium-text d-block">Email</label>
              <label>{{ provider.email || "--"  }}</label>
            </div> -->
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Phone</label>
              <label>{{ provider.phone || '--' }}</label>
              <label *ngIf="provider.extn && provider.extn !== '--'">&nbsp; extn.&nbsp;{{provider.extn}}</label>
            </div>
          </div>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Fax</label>
              <label>{{ provider.fax || "--" }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Email</label>
              <label>{{ provider.email || "--" }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Record Subject</label>
              <label data-openreplay-obscured>{{ provider.recordSubject }}</label>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label class="medium-text d-block">Record Range</label>
              <label>{{ provider.recordRange }}</label>
            </div>
          </div>
          <div class="row mb-0 mb-lg-3">
            <div class="col-sm-12 mb-3 mb-sm-0">
              <label class="medium-text d-block">Record Type Requested</label>
              <label>{{provider.recordType}}</label>
            </div>
            <div class="col-sm-12 mb-3 mb-sm-0">
              <label class="medium-text d-block" *ngIf="provider.imaging.type || provider.ambulance.date ||
                provider.employment.ss || provider.insurance.claimNumber || provider.irs.ss ||
                provider.military.branch || provider.socialSecurity.ss || provider.union.membershipNumber ||
                provider.va.va || provider.other.descriptionOfRecords">
                Additional Details:
              </label>
              <ul>
                <li class="mb-2" *ngIf="provider.recordType.includes('Diagnostic Images')">
                  <label class="text-underline semi-bold-text heading-color">Type of Imaging: </label>
                  <div>
                    <span>{{provider.imaging.type || '--'}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1" *ngIf="provider.imaging.type.includes('Other')">
                    <label class="medium-text">Other: </label>
                    <span>{{provider.imaging.others}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1" *ngIf="provider.imaging">
                    <label class="medium-text">Specific Body Part/Area: </label>
                    <span class="overflow-wrap">{{provider.imaging.specificBodyPart || '--'}}</span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.ambulance.date">
                  <label class="text-underline semi-bold-text heading-color">Ambulance: </label>
                  <div class="d-flex flex-row gap-1" *ngIf="provider.ambulance.date">
                    <label class="medium-text">Date of Ambulance Service: </label>
                    <span>{{provider.ambulance.date | date: 'MM/dd/yyyy'}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1" *ngIf="provider.ambulance">
                    <label class="medium-text">Time of Ambulance Service: </label>
                    <span class="overflow-wrap">{{provider.ambulance.time || '--'}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1" *ngIf="provider.ambulance">
                    <label class="medium-text">Pick-up Address: </label>
                    <span class="overflow-wrap" data-openreplay-obscured>{{provider.ambulance.pickupAddress || '--'}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1" *ngIf="provider.ambulance">
                    <label class="medium-text">Drop Address: </label>
                    <span class="overflow-wrap" data-openreplay-obscured>{{provider.ambulance.dropAddress || '--'}}</span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.employment.ss">
                  <label class="text-underline semi-bold-text heading-color">Employment: </label>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">SS#: </label>
                    <span data-openreplay-obscured>{{provider.employment.ss}} </span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.insurance.claimNumber">
                  <label class="text-underline semi-bold-text heading-color">Insurance: </label>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Claim Number: </label>
                    <span>{{provider.insurance.claimNumber}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Policy Number: </label>
                    <span class="overflow-wrap">{{provider.insurance.policyNumber || '--'}}</span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.irs.ss">
                  <label class="text-underline semi-bold-text heading-color">IRS: </label>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">SS#: </label>
                    <span data-openreplay-obscured>{{provider.irs.ss}}</span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.recordType.includes('Military')">
                  <label class="text-underline semi-bold-text heading-color">Military: </label>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Branch (if known) : </label>
                    <span>{{provider.military.branch || '--'}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Service Number (if known) : </label>
                    <span class="overflow-wrap">{{provider.military.serviceNumber || '--'}}</span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.socialSecurity.ss">
                  <label class="text-underline semi-bold-text heading-color"> Social Security: </label>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">SS# : </label>
                    <span data-openreplay-obscured>{{provider.socialSecurity.ss}}</span>
                  </div>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Record Subject Address: </label>
                    <span class="overflow-wrap" data-openreplay-obscured>{{provider.socialSecurity.address}}</span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.union.membershipNumber">
                  <label class="text-underline semi-bold-text heading-color"> Union: </label>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Membership Number (if known) : </label>
                    <span>{{provider.union.membershipNumber || '--'}}</span>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.recordType.includes('VA')">
                  <label class="text-underline semi-bold-text heading-color"> VA: </label>
                  <div>
                    <label>{{provider.va.va || '--'}} </label>
                  </div>
                </li>
                <li class="mb-2" *ngIf="provider.other.descriptionOfRecords">
                  <label class="text-underline semi-bold-text heading-color"> Other: </label>
                  <div class="d-flex flex-row gap-1">
                    <label class="medium-text">Description of records : </label>
                    <span>{{provider.other.descriptionOfRecords}}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="row mb-0 mb-lg-3" *ngIf="provider.subpoenaLanguage">
            <div class="col-sm-12 mb-3 mb-sm-0">
              <label class="medium-text">Subpoena Language</label>
              <p class="m-0">
                {{ provider.subpoenaLanguage }}
              </p>
            </div>
          </div>
          <div class="row mb-0 mb-lg-3" *ngIf="provider.notes">
            <div class="col-sm-12 mb-3 mb-sm-0">
              <label class="medium-text">Notes</label>
              <p class="m-0">
                {{ provider.notes }}
              </p>
            </div>
          </div>
          <!-- } -->
      <!--Request attachments section -->
      <section class="border-top-dotted mt-3">
        <label class="semi-bold-text mb-2 font-15 mt-3">Attachments</label>
        <div class="row mb-0 mb-lg-3">
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0 labelContainer">
            <label class="medium-text d-block mb-1">Label</label>
            <div class="d-grid gap-0 row-gap-2">
              <div *ngFor="let attachment of requestDocumentsMap.get(item.key)">
              <label>{{ getRequestDocTitleTagName(attachment, vocabDocumentTagsData) }}</label>
              </div>
              <div *ngIf="!requestDocumentsMap.get(item.key)?.length">
              <label>--</label>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
            <label class="medium-text d-block mb-1">Uploaded Files</label>
            <div class="d-grid gap-0 row-gap-2">
              <div *ngFor="let attachment of requestDocumentsMap.get(item.key)">
              <p-button aria-label="Downloadable File" styleClass="p-0" label="{{ attachment.fileName }}" (onClick)="downloadRequestFile(attachment)" [link]="true" />
              </div>
              <div *ngIf="!requestDocumentsMap.get(item.key)?.length">
              <label>--</label>
              </div>
            </div>
          </div>
        </div>
      </section>
           @if (!isLast) {
           <hr>
          }

          </ng-container>
        </ng-container>
    </section>
    <!-- </div> -->
  </p-panel>
</section>
